import React, {useContext} from "react";
import {Tag} from "antd";
import {UserContext} from "@context/UserContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";

export const ADMIN_ID_TAG_TYPES = {
    QUESTION: "Question",
    MEDIA: "Media"
}

const AdminIdTag = props => {
    const {id, type} = props;
    const {user} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();

    const handleOnClick = () => {
        if (type === ADMIN_ID_TAG_TYPES.QUESTION) {
            const url =  "/administration/question/manageQuestions.action";
            globalReactFunctions.questionTabsActiveTab = 1;
            loadShortcutByUrl(url, {questionId: id});
        } else if (type === ADMIN_ID_TAG_TYPES.MEDIA) {
            console.log('load media', id);
        }
    }

    if (!user?.showResourceIds || !user?.adminUser) return null;

    return (
        <Tag
            className="margin-t--m margin-b--s"
            href="#"
            variant={"outline"}
            onClick={handleOnClick}
        >
            {type}: {id}
        </Tag>
    )
}

export default AdminIdTag;